module.exports = __webpack_public_path__ + "static/telensa-app-preview-98aab22ece22489bd1f946092a0a25a8.png";